import { OPTIMIZATION_TYPES } from './Inventory/components/DiscocoveryInventoryDrawer/constants';

export const getUtilizationCriteria = (utilization) => {
    if (utilization == null) return null;
    if (utilization <= 0.2) return OPTIMIZATION_TYPES.OVERSIZED;
    if (utilization >= 0.8) return OPTIMIZATION_TYPES.UNDERSIZED;
    return 'ready';
};

export const returnPowerState = (record) => {
    const powerStates = {
        poweredOff: 'Off',
        poweredOn: 'Running',
        suspended: 'Unknown',
    };

    return powerStates[record?.power_state] || 'N/A';
};

// Oversized wins if any disk is over-provisioned by >1 GiB; then undersized if any disk has >1 GiB in use.
export const getStorageCriteria = (storageDiskSizes, storageDisksUsed, storageUtilization) => {
    if (!storageDiskSizes?.length || !storageDisksUsed?.length || !storageUtilization?.length) return null;
    const ONE_GB_MIB = 1024;
    for (let i = 0; i < storageDiskSizes.length; i++) {
        if (storageUtilization[i] === 'oversized' && (storageDiskSizes[i] - storageDisksUsed[i]) > ONE_GB_MIB) {
            return 'oversized';
        }
    }
    for (let i = 0; i < storageDiskSizes.length; i++) {
        if (storageUtilization[i] === 'undersized' && storageDisksUsed[i] > ONE_GB_MIB) {
            return 'undersized';
        }
    }
    return 'ready';
};

export const returnTotalDiskCriteria = (row) => {
    // Calculate total and used storage across all disks
    const totalSpace = row?.storage_disks?.reduce((sum, disk) => sum + disk, 0);
    const totalUsed = row?.storage_disks_used?.reduce((sum, used) => sum + used, 0);
    const usedPercentage = (totalUsed / totalSpace) * 100;

    let criteria;
    if (usedPercentage > 80) {
        criteria = 'undersized';
    } else if (usedPercentage < 20) {
        criteria = 'oversized';
    } else if (usedPercentage > 20 && usedPercentage < 80) {
        criteria = 'ready';
    }

    return { criteria, totalSpace, totalUsed };
};

// Check that the IP Addresses array has at least one IPv4 IP (not empty and not IPv6)
export const hasValidIP = (ipAddresses) => {
    return ipAddresses?.some((ip) => ip && ip.trim() !== '' && !ip.includes(':'));
};

export const hasOptimizations = (obj) => {
    if (obj == null || typeof obj !== 'object') {
        return false;
    }

    return Object.values(obj).some((value) => {
        if (!value) {
            return false;
        }
        if (Array.isArray(value)) {
            return value.length > 0;
        }
        if (typeof value === 'object') {
            return hasOptimizations(value);
        }
        return true;
    });
};

